/*
 * Vieux archive group (spec 2026-10-04 §4, approved prototype CP4 2026-10-16): the product page's
 * "Archive N" row (snippets/variant-main-picker.liquid, [data-vieux-archive-card]) opens and closes
 * its archived swatches. The server renders it open for an archived pick, a ?variant= link to one,
 * the archive view and a fully archived frame (no toggle); everything else starts closed.
 * A colour change re-renders the picker from the server (variant-picker.js morph, then
 * `variant:update`), which would close a group the shopper opened by hand: it is re-opened here,
 * so picking a current colour never closes it (as in the prototype). Runs once.
 */
if (!window.__vieuxArchiveGroup) {
  window.__vieuxArchiveGroup = true;

  /** Product ids whose group the shopper opened. */
  const opened = new Set();

  /** @param {Element} card @param {boolean} open */
  const setOpen = (card, open) => {
    card.classList.toggle('is-expanded', open);
    card.querySelector('[data-vieux-archive-toggle]')?.setAttribute('aria-expanded', String(open));
  };

  document.addEventListener('click', (event) => {
    const target = /** @type {Element | null} */ (event.target instanceof Element ? event.target : null);
    const head = target?.closest('[data-vieux-archive-toggle]');
    if (!(head instanceof HTMLButtonElement) || head.disabled) return;
    const card = head.closest('[data-vieux-archive-card]');
    if (!card) return;
    event.preventDefault();
    const open = !card.classList.contains('is-expanded');
    setOpen(card, open);
    const id = card.getAttribute('data-product-id') || '';
    if (open) opened.add(id);
    else opened.delete(id);
  });

  document.addEventListener('variant:update', () => {
    document.querySelectorAll('[data-vieux-archive-card]').forEach((card) => {
      if (opened.has(card.getAttribute('data-product-id') || '')) setOpen(card, true);
    });
  });
}
